import React from 'react';
import { bool, func, object, string } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import { SavedCardDetails } from '../../components';
import { PaymentMethodsForm } from '../../forms';

import css from './BillingPage.css';

// Section 2's card block (spec §3). Adding or replacing a card needs a
// complete billing profile (its address is what Stripe gets); an existing
// card is always shown and removable; approved invoice customers keep an
// earlier card but do not add one (decision 11).
const PaymentCardSection = props => {
  const {
    stripeCustomerFetched,
    card,
    isInvoiceBilled,
    canAddCard,
    cardState,
    onCardStateChange,
    onDeleteCard,
    deletePaymentMethodInProgress,
    onManageDisableScrolling,
    formInitialValues,
    onSubmitCard,
    submitInProgress,
    addPaymentMethodError,
    deletePaymentMethodError,
    createStripeCustomerError,
    handleCardSetupError,
  } = props;

  if (!stripeCustomerFetched) return null;

  const hasCard = !!card;
  const showForm = canAddCard && (cardState === 'replaceCard' || !hasCard);
  const hintId = isInvoiceBilled
    ? 'BillingPage.noCardInvoiced'
    : 'BillingPage.completeBillingFirst';

  return (
    <div className={css.cardBlock}>
      {isInvoiceBilled && hasCard ? (
        <h4 className={css.savedCardTitle}>
          <FormattedMessage id="BillingPage.savedCardTitle" />
        </h4>
      ) : null}
      {hasCard ? (
        <SavedCardDetails
          card={card}
          disableReplaceCard={!canAddCard}
          onManageDisableScrolling={onManageDisableScrolling}
          onChange={onCardStateChange}
          onDeleteCard={onDeleteCard}
          deletePaymentMethodInProgress={deletePaymentMethodInProgress}
        />
      ) : null}
      {showForm ? (
        <PaymentMethodsForm
          formId="BillingPageCard"
          showAddress={false}
          compact
          initialValues={formInitialValues}
          onSubmit={onSubmitCard}
          addPaymentMethodError={addPaymentMethodError}
          deletePaymentMethodError={deletePaymentMethodError}
          createStripeCustomerError={createStripeCustomerError}
          handleCardSetupError={handleCardSetupError}
          inProgress={submitInProgress}
        />
      ) : null}
      {!hasCard && !canAddCard ? (
        <p className={css.muted}>
          <FormattedMessage id={hintId} />
        </p>
      ) : null}
    </div>
  );
};

PaymentCardSection.defaultProps = {
  card: null,
  cardState: null,
  addPaymentMethodError: null,
  deletePaymentMethodError: null,
  createStripeCustomerError: null,
  handleCardSetupError: null,
};

PaymentCardSection.propTypes = {
  stripeCustomerFetched: bool.isRequired,
  card: object,
  isInvoiceBilled: bool.isRequired,
  canAddCard: bool.isRequired,
  cardState: string,
  onCardStateChange: func.isRequired,
  onDeleteCard: func.isRequired,
  deletePaymentMethodInProgress: bool.isRequired,
  onManageDisableScrolling: func.isRequired,
  formInitialValues: object.isRequired,
  onSubmitCard: func.isRequired,
  submitInProgress: bool.isRequired,
  addPaymentMethodError: object,
  deletePaymentMethodError: object,
  createStripeCustomerError: object,
  handleCardSetupError: object,
};

export default PaymentCardSection;
